module.exports = __webpack_public_path__ + "img/dark-s_py.59a6fc5f.jpg";